import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export default function MarketingLayout({ children, wide = false }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div style={{ minHeight: "100vh", background: "var(--surface)", display: "flex", flexDirection: "column" }}>
      <header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 28px", borderBottom: "1px solid var(--line)", position: "sticky", top: 0, background: "var(--surface)", zIndex: 20 }}>
        <div style={{ cursor: "pointer" }} onClick={() => navigate(user ? "/" : "/landing")}><Logo height={54} /></div>
        <nav style={{ display: "flex", alignItems: "center", gap: 18 }}>
          <span style={{ cursor: "pointer", fontWeight: 700, fontSize: 14 }} onClick={() => navigate("/about")} data-testid="nav-about">About</span>
          <span style={{ cursor: "pointer", fontWeight: 700, fontSize: 14 }} onClick={() => navigate("/help")} data-testid="nav-help">Help</span>
          <span style={{ cursor: "pointer", fontWeight: 700, fontSize: 14 }} onClick={() => navigate("/contact")} data-testid="nav-contact">Contact</span>
          <button className="ss-btn ss-btn-primary ss-btn-sm" onClick={() => navigate(user ? "/" : "/login")} data-testid="nav-cta">{user ? "Back to app" : "Log in"}</button>
        </nav>
      </header>

      <main style={{ flex: 1, width: "100%", maxWidth: wide ? 1100 : 860, margin: "0 auto", padding: "34px 22px 60px" }}>
        {children}
      </main>

      <footer style={{ borderTop: "1px solid var(--line)", padding: "26px 22px", background: "var(--surface-2)" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", flexWrap: "wrap", gap: 16, justifyContent: "space-between", alignItems: "center" }}>
          <div className="ss-muted" style={{ fontSize: 13 }}>
            © {new Date().getFullYear()} Contract 2 Cash LLC — Where Live Shopping, Community &amp; Giving Come Together.
            {" "}Developed by{" "}
            <a href="https://www.inubaanlabs.com" target="_blank" rel="noopener noreferrer" data-testid="footer-inubaan" style={{ color: "var(--brand)", fontWeight: 700 }}>Inubaan Labs</a>.
          </div>
          <div style={{ display: "flex", gap: 18, fontSize: 13, fontWeight: 700 }}>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/about")}>About</span>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/help")} data-testid="footer-help">Help &amp; FAQ</span>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/contact")}>Contact</span>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/privacy")} data-testid="footer-privacy">Privacy</span>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/terms")} data-testid="footer-terms">Terms</span>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/seller-policy")} data-testid="footer-seller-policy">Seller Policy</span>
            <span style={{ cursor: "pointer" }} onClick={() => navigate("/delete-account")} data-testid="footer-delete">Delete account</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
